/*******************************************************************************
Smart Anchor Tags
When an anchor tag is clicked, this function:
1. Scrolls smoothly rather than jumping to the anchor.
2. Prevents the #hash from showing up in the URL address bar.
3. Prevents the named element from being flush with the top of the screen.
*******************************************************************************/
import removeHashesFromURL from './remove-hashes-from-url';

export default function activateSmartAnchorTags() {

    // Scrolls smoothly rather than jumping to the anchor.
    const anchorHash = (this) ? this.hash : window.location.hash;
    try {
        if (anchorHash && $(anchorHash).length > 0) {
            $('html, body').animate({ scrollTop: $(anchorHash).offset().top }, 300);
        }
        // Prevents the #hash from showing up in the URL address bar.
        setTimeout(() => { removeHashesFromURL(); }, 10);

        // Prevents the named element from being flush with the top of the screen.
        setTimeout(() => { window.scrollTo(window.scrollX, window.scrollY - 10); }, 310);
    }
    catch (error) {
        // No need to do anything. It's likely an invalid selector in which case the code above is irrelevant
    }

}
